import { ConfirmDialog } from '@/components/feedback/ConfirmDialog';
import { graphql, type DocumentType } from '@/gql';
import { useMutation } from '@/hooks/mutationWithSnackbar';

const DELETE_COMMENT_MUTATION = graphql(`
  mutation DeleteComment($data: DeleteCommentFromPostInput) {
    deleteCommentFromPost(params: $data) {
      post {
        ...postFields
      }
    }
  }
`);

const POST_COMMENT_DELETE_DIALOG_COMMENT_FRAGMENT = graphql(`
  fragment postCommentDeleteDialogCommentFragment on PostComment {
    _id
  }
`);

const POST_COMMENT_DELETE_DIALOG_POST_FRAGMENT = graphql(`
  fragment postCommentDeleteDialogPostFragment on Post {
    _id
  }
`);

interface Props {
  comment: DocumentType<typeof POST_COMMENT_DELETE_DIALOG_COMMENT_FRAGMENT>;
  post: DocumentType<typeof POST_COMMENT_DELETE_DIALOG_POST_FRAGMENT>;
  open: boolean;
  onClose: () => void;
}

export const PostCommentDeleteDialog = ({
  comment,
  post,
  open,
  onClose,
}: Props) => {
  const { _id: commentId } = comment;
  const { _id: postId } = post;

  const [deleteComment, { loading }] = useMutation(DELETE_COMMENT_MUTATION, {
    completionMessage: 'Comment deleted',
  });

  return (
    <ConfirmDialog
      ariaLabel="post-comment-delete"
      titleText="Are you sure you want to delete this comment?"
      innerText="After doing so it will not be visible to anyone, but people may still have copies of it in their email inboxes"
      confirmText="Delete"
      confirmButtonProps={{ color: 'error' }}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={() => {
        deleteComment({
          variables: {
            data: {
              comment: commentId,
              post: postId,
            },
          },
        });
      }}
    />
  );
};
